const filterDefined = obj => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );
};

const applySetUser = ({ identifier, identifierHash, name, email, phoneNumber, avatarUrl, countryCode, companyName }) => {
  window.$chatwoot.setUser(identifier, filterDefined({
    identifier_hash: identifierHash,
    email,
    name,
    phone_number: phoneNumber,
    avatar_url: avatarUrl,
    country_code: countryCode,
    company_name: companyName,
  }));
};

const applySetCustomAttributes = customAttributes => {
  const filtered = filterDefined(customAttributes);
  if (Object.keys(filtered).length > 0) {
    window.$chatwoot.setCustomAttributes(filtered);
  }
};

export const ChatwootChat = {
  setUser: params => {
    if (window.$chatwoot) {
      applySetUser(params);
    } else {
      const onReady = () => {
        applySetUser(params);
        window.removeEventListener('chatwoot:ready', onReady);
      };
      window.addEventListener('chatwoot:ready', onReady);
    }
  },
  setCustomAttributes: customAttributes => {
    if (window.$chatwoot) {
      applySetCustomAttributes(customAttributes);
    } else {
      const onReady = () => {
        applySetCustomAttributes(customAttributes);
        window.removeEventListener('chatwoot:ready', onReady);
      };
      window.addEventListener('chatwoot:ready', onReady);
    }
  },
  reset: () => {
    if (window.$chatwoot) {
      window.$chatwoot.reset();
    }
  },
};